export { useLocaleDateTime } from './context';

export const periodDurationMap = {
  Second: 'seconds',
  Minute: 'minutes',
  Hour: 'hours',
  Day: 'days',
  Week: 'weeks',
};
